import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { ExamcompassClient } from '../Api/api';
import axios from 'axios';
import { PasswordResetErrorType, ForgotPasswordType } from '../interface';


// svg
import logoTwo from '../Assets/compass-logo-2.svg'
import lady from '../Assets/lady.svg'
import { Link } from 'react-router-dom'


const Forgotpassword: React.FC = () => {
  const [resetPassword, setResetPassword] = useState<ForgotPasswordType>({
    email: '',
    username: ''
  })
  console.log(resetPassword);
  const [fieldError, setFieldError] = useState<PasswordResetErrorType | null>(null);
  const [nonFieldError, setNonFieldError] = useState<string>('');
  console.log('error:', fieldError);
  console.log('nonFieldError:', nonFieldError);


  const handleResetPasswordInputs = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { name, value } = e.target;
    setResetPassword(prev => ({ ...prev, [name]: value }))
  }
  
  const navigate = useNavigate();

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();

    const userEmail = {
      email: resetPassword?.email,
      username: resetPassword?.username
    }

    try {
      const response = await ExamcompassClient.post('/profile/reset_password/', userEmail)
      console.log(response?.status)
        console.log('Password reset request successful');
        setResetPassword({
          email: '',
          username: ''
        })
      navigate('/reset-verification');
    }
    catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        // console.log(error?.response?.data?.email[0]);
        console.log("This is the error message:", error?.response?.data);
        const updateError = error?.response?.data;
        if (updateError && typeof updateError === 'object' && !updateError?.bank_data?.[0]?.non_field_errors) {
          setFieldError(updateError);
          // setNonFieldError(updateError);
        }
        else if (updateError && typeof updateError === 'object' && updateError?.non_field_errors) {
          setNonFieldError(updateError?.bank_data?.[0]?.non_field_errors[0]);
        }
      }
    }
  }

  return (
    <section className='w-full h-[100vh] relative bg-slate-200 overflow-hidden'>
      <div className='md:w-[50%] lg:w-[480px] h-[100%] bg-white pt-5 px-6 lg:px-16 pb-5 flex flex-col justify-between'>
        <div>
          <div className='mb-4'>
            <Link to={'/'}><img className='w-[50px]' src={logoTwo} alt="ExamCompass" /></Link>
          </div>
          <div className='mb-5'>
            <h2 className='w-[50%] text-[30px] text-darkGreen font-bold mb-4'>Forgot password?</h2>
            <p className='w-full  text-[0.825em] leading-[24px]'>Don’t worry we can help you out! If you still remember your email address you can quickly reset your password. Just input that information in the fields below and click on the button. This will send you a new email that will link you to the password change website.</p>
          </div>

          <form onSubmit={handleResetPassword}>
            <div className='mb-4'>
              <div className='w-full mb-1 flex items-center justify-between'>
                <p className='lg:text-[14px] mb-1'>Email address</p>
                <p className='lg:text-[14px] text-red-700 mb-1'>{fieldError?.email[0]}</p>
              </div>
              <input type='email'
               placeholder='your@example.com'
               name='email'
               value={resetPassword?.email}
                onChange={handleResetPasswordInputs}
               className='w-full h-[40px] p-2 text-[0.825em] border border-textColor outline-none' />
            </div>
            <div className='mb-4'>
              <div className='w-full mb-1 flex items-center justify-between'>
                <p className='lg:text-[14px]'>Username</p>
                <p className='lg:text-[14px] text-red-700 mb-1'>{fieldError?.username[0]}</p>
              </div>
              <input type='text'
                placeholder='username'
                name='username'
                value={resetPassword?.username}
                onChange={handleResetPasswordInputs}
                className='w-full h-[40px] p-2 text-[0.825em] border border-textColor outline-none' />
            </div>

            <button className='bg-darkGreen text-white w-full lg:text-[14px] h-[39px] lg:h-[48px] rounded-[4px] cursor-pointer'>Request password</button>
          </form>
        </div>

        <div>
          <p className='text-textColor text-[14px] lg:text-[14px] font-semibold text-center'>Do you need help</p>
          <p className='text-darkGreen text-[14px] lg:text-[14px] font-semibold text-center'>Customer support</p>
        </div>
      </div>

      <img className='hidden md:block absolute w-[1000px] md:w-[600px] lg:w-auto lg:h-[700px]  bottom-0 -right-[150px] lg:-right-0' src={lady} alt='Lady' />
    </section>
  )
}

export default Forgotpassword